import { Link } from 'react-router-dom';

/**
 * Renders the "source page" cell shown on every consolidated extraction row
 * (DR-1630). Falls back to "—" when `pageId` is missing (legacy entities
 * extracted before the per-row provenance landed) or unresolvable against the
 * current entity's pages array. The friendly label is the constituent page's
 * 1-based position; clicking jumps to `/document-pages/<pageId>` so a reviewer
 * can drill into the page that produced the row.
 */
export function SourcePageCell({
  pageId,
  pageIdToPosition,
}: {
  pageId: string | undefined;
  pageIdToPosition: Map<string, number>;
}) {
  if (!pageId) return <>—</>;
  const position = pageIdToPosition.get(pageId);
  return (
    <Link
      to={`/document-pages/${pageId}`}
      className="text-blue-600 dark:text-blue-400 hover:underline whitespace-nowrap"
      title={pageId}
      onClick={(e) => e.stopPropagation()}
    >
      → {position != null ? `Page ${position}` : 'Page'}
    </Link>
  );
}
